module.exports = __webpack_public_path__ + "img/full-stack-engineer.2e160c15.jpg";